var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from 'styled-components';
import { border } from 'styled-system';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
const styleAsButton = (_a) => {
    var { as } = _a, props = __rest(_a, ["as"]);
    return as === 'button'
        ? `
      font-family : inherit;
      &:hover {
        cursor: pointer;
        box-shadow: ${props.theme.shadows.xl};
      }`
        : '';
};
const cardPropTypes = {
    borderColor: deprecatedColorValue(),
    color: deprecatedColorValue(),
    borderWidth: PropTypes.oneOf([0, 1, 2]),
};
const Card = styled(Box) `
  ${applyVariations('Card')}
  ${styleAsButton}

  border-color: ${(props) => props.borderWidth === 0 ? '0' : getPaletteColor(props.borderColor, 'base')(props)};
  ${border};
`;
Card.propTypes = cardPropTypes;
Card.defaultProps = {
    borderColor: 'border',
    borderRadius: 'xsm',
    borderStyle: 'solid',
    borderWidth: 1,
};
Card.displayName = 'Card';
export default Card;
//# sourceMappingURL=Card.js.map